import React, {useEffect, useState} from 'react'
import './pms.css'
import { Button } from '@mui/material'
import { Link } from 'react-router-dom';
import ScrollToTop from '../../../../components/Scroll/ScrollToTop'



import img_pms1 from './img_pms/OHO-PMS-P1-MODULE.jpg'
import img_pms2 from './img_pms/OHO-PMS-P2-MODULE.jpg'

export default function Pms(){

    const [scrollX, setScrollX] = useState(0);
    const [scrollY, setScrollY] = useState(0);

    
    const [openModal1, setOpenModal1] = useState(false);
    const [openModal2, setOpenModal2] = useState(false);
    const [openButton1, setOpenButton1] = useState(false);
    const [openButton2, setOpenButton2] = useState(false);

    function handleModal1(){
        setOpenModal1(true)
        setOpenButton1(true)
    }
    function handleModal2(){
        setOpenModal2(true)
        setOpenButton2(true)
    }

    function handleModalClose1(){
        setOpenModal1(false)
        setOpenButton1(false)
    }
    function handleModalClose2(){
        setOpenModal2(false)
        setOpenButton2(false)
    }

    useEffect(() => {
        window.scrollTo(scrollX, scrollY)
      }, [])

    return(
        <div className='pms'>
        <ScrollToTop/>
            <div className='pms-header'>
                <ul className="vision--head box"></ul>
                <ul>OHO PMS</ul>
            </div>
            <div className='pms-body'>
                <ul>
                    <p>ซอฟต์แวร์ OHO PMS SYSTEM โปรแกรมบริหารจัดการโรงแรมและรีสอร์ท เป็น Software โรงแรม ที่ออกแบบสำหรับ งานบริหารงาน โรงแรม , อพาร์ทเมนต์ รายวัน , รีสอร์ท โดยส่วนประกอบหลักๆของ โปรแกรมโรงแรม จะประกอบไปด้วย ระบบการจองห้องพัก (Reservation) , ระบบการเช็คอิน ( Check In ) , ระบบการเช็คเอาท์ ( Check Out ) , ระบบข้อมูลผู้เข้าพัก ( Guest Registration) , ระบบการขายสินค้า , ระบบการซื้อสินค้า , ระบบสต็อกสินค้า ( Inventory ) , ระบบแม่บ้าน ( House Keeping ) , ระบบการบำรุงรักษาห้องพัก ( Room Maintain ) , ระบบ Night auditor และ ระบบ การออกเอกสาร ต่างๆ อาทิเช่น ใบเสร็จรับเงิน , FOLIO , ใบกำกับภาษี , คูปองอาหาร เป็นต้น รวมไปทั้งระบบการรายงาน และ รายงานเชิงวิเคราะห์ อาทิเช่น รายงานประวัติผู้เข้าพัก , รายงานการรับเงินของ Cashier , รายงานการเข้าพัก , รายงานสรุปยอดห้องพักคงเหลือ ( Room Planning ) , รายงานสินค้าคงเหลือ ทั้ง สต๊อกกลาง (Central stock) และ สต๊อกมืนิบาร์ (Minibar stock) , มีระะบบรายงานการใช้งานห้องพัก ( Room Occupancy ) , รายงานยอดการจองห้องพักล่วงหน้า ( Forecast Report ) และ รายงานอื่นๆ อีกมากมาย ซึ่ง โปรแกรมรองรับการทำงานได้หลายภาษา ทั้ง ภาษาไทย , ภาษาอังกฤษ และ ภาษาอื่นๆ และ สามารถทำงานได้บน Internet cloud</p>
                </ul>
                <br/>
                <ul>
                    <p>บริษัทให้บริการในการพัฒนาระบบงานด้วยทีมงานผู้มีประสบการณ์ ทั้งทางด้านเทคโนโลยีสารสนเทศ การจัดการและผู้เชี่ยวชาญ เพื่อแบ่งเบาภาระในการบริหารงาน การจัดการโครงงานและการพัฒนาระบบงานทางด้านเทคโนโลยีสารสนเทศของทางบริษัทผู้ใช้บริการ รวมถึงการดูแลรักษาระบบงานให้สามารถตอบสนองความต้องการของบริษัทผู้ใช้บริการ เพื่อเพิ่มศักยภาพในการแข่งขันทางธุรกิจ</p>
                </ul>
                <br/>
                <ul>
                    <p>การบริการพัฒนาระบบงานของทางบริษัทที่พร้อมให้บริการกับทางบริษัทผู้ใช้บริการ จะสามารถอำนวยประโยชน์ได้ดังนี้</p>
                    <li>ระบบงานสามารถส่งมอบตรงตามเวลาตามที่ทางบริษัทผู้ใช้บริการ ต้องการด้วยทีมงานคุณภาพของบริษัทที่พร้อมทุ่มเทให้บริการ เพื่อพัฒนาระบบงานให้สอดคล้องกับความต้องการในเวลาที่กำหนด และงบประมาณที่เหมาะสม</li>
                    <li>ระบบงานทันสมัยที่สามารถเชื่อมต่อกับ เทคโนโลยีปัจจุบันของบริษัทและรองรับเทคโนโลยีในอนาคต  เนื่องจากบริษัทมีทีมงานที่มีความรู้ความชำนาญในระบบงาน พร้อมทั้งมีความเชี่ยวชาญ ด้านเทคโนโลยีระบบเปิด ที่มีความคล่องตัว หลากหลาย และครอบคลุมโครงสร้าง ของเทคโนโลยีปัจจุบันและอนาคตได้เป็นอย่างดี</li>
                </ul>
            </div>
            <br/>
            <br/>
            <div className='pms-header'>
                <ul className="vision--head box"></ul>
                <ul>ประโยชน์ที่จะได้จากการใช้ OHO HOTEL & RESORT SYSTEM</ul>
            </div>
            <div className='pms-body'>
                <ul>
                    <li><b>ลดภาระการทำงาน</b> ถ้าทุกอย่างต้องใช้คนทำงานทุกขั้นตอนในขณะที่สามารถใช้ระบบทำงานแทนได้ ก็เหมือนกับเป็นการใช้ทรัพยากรบุคคลไม่คุ้มค่า ทำให้เสียค่าใช้จ่ายโดยไม่จำเป็น ระบบบริหารโรงแรมสามารถลดภาระการปฏิบัติงานของคุณได้ ยกตัวอย่างเช่น การทำรายงานการจองอัตโนมัติโดยที่คุณไม่ต้องให้คนมานั่งเช็คเอกสารเป็นปึกๆเพื่อออกรายงาน หรือ การที่คุณสามารถจัดการจองสำหรับแขกที่มาเป็นกลุ่มได้ภายในไม่ถึงนาที จากที่ต้องมานั่งเขียนก็ให้ระบบทำงานแทนไป ง่ายกว่ากันเยอะ</li>
                    <li><b>ลดข้อผิดพลาดจากการทำงาน</b> แน่นอนมนุษย์ย่อมทำสิ่งผิดพลาด แต่คุณสามารถลดความผิดพลาดที่อาจเกิดจากคนได้ถ้าใช้ระบบเข้ามาควบคุม ข้อผิดพลาดที่เกิดบ่อยๆ เช่น การที่คุณทำเอกสารการจองของลูกค้าหายทำให้ลูกค้าไม่มีห้องพัก หรือการลืมบวกค่าอาหารเข้าไปในFolioของลูกค้า ข้อผิดพลาดแบบนี้แทบจะไม่มีถ้าคุณมีโปรแกรมเข้ามาช่วยบริหาร</li>
                    <li><b>ช่วยให้การทำงานเร็วขึ้น</b> ความเร็วในการบริการถือเป็นสิ่งสำคัญสำหรับลูกค้า ถ้าต้องรออะไรนานๆลูกค้าย่อมไม่พอใจอย่างแน่นอน ลองคิดดูว่าเมื่อลูกค้าเข้ามาเช็คอินแล้วต้องรอเป็นสิบนาทีกว่าคุณจะทำการเช็คอินเสร็จ ทั้งๆที่ลูกค้าก็เดินทางมาไกล เกิดความเหนื่อยล้า อยากเข้าไปพักผ่อนในห้องเร็วๆ แต่คุณยังทำอะไรไม่รู้ไม่เสร็จซักที ถ้าคุณมีระบบ ปัญหานั้นจะหมดไป เพราะคูณสามารถทำการเช็คอินได้ทันทีโดยไม่ต้องมานั่งกรอกข้อมูลที่ลูกค้าจองมาให้ซ้ำซาก ลดเวลาไปได้อีกเยอะ</li>
                    <li><b>ช่วยให้การทำงานเป็นระบบและตรวจสอบได้</b> คุณสามารถมั่นใจได้ว่าทุกขั้นตอนการทำงานของแต่ละแผนกสามารถทำงานผสานกันได้อย่างเป็นระบบและตรวจสอบได้ เพราะโปรแกรมบริหารโรงแรมที่ดีนั้นจะมีการออกแบบขั้นตอนการทำงานเพื่อให้พนักงานสามารถทำงานเป็นขั้นเป็นตอน อีกทั้งคุณยังสามารถตรวจสอบได้ว่าใครเป็นผู้ทำงานในเวลานั้นๆ</li>
                    <li><b>ช่วยให้การสื่อสารภายในองค์กรมีประสิทธิภาพ</b> แต่ละแผนกสามารถรับส่งการทำงานได้อย่างมีประสิทธิภาพเพราะข้อมูลต่างๆมีการอัพเดทให้เป็นปัจจุบันอยู่เสมอ ยกตัวอย่าง แผนกต้อนรับส่วนหน้าสามารถส่งต่องานทำความสะอาดให้แผนกแม่บ้านเมื่อมีแขกเช็คเอาท์ได้ทันที</li>
                    <li><b>ใช้ประโยชน์จากข้อมูลเพื่อการวิเคราะห์และตรวจสอบได้ดีขึ้น</b> ข้อมูลที่ละเอียดและแม่นยำถือเป็นอาวุธหลักของผู้บริหารที่จะใช้ในการวิเคราะห์ ตรวจสอบ และปรับปรุงธุรกิจให้ดีขึ้น โปรแกรมบริหารโรงแรมสามารถจัดทำรายงานชนิดๆต่างๆให้ผู้จัดการหรือผู้บริหารได้โดยการกดปุ่มแค่ครั้งเดียว ถ้าคุณอยากดูข้อมูลการจองเปรียบเทียบย้อนหลังสองปีก็ทำได้ แต่ถ้าคุณไม่มีระบบ คุณก็ต้องให้พนักงานไปหาเอกสารเก่าๆเพื่อจัดทำรายงานให้คุณ ซึ่งยุ่งยากและกินเวลา จนท้ายที่สุดคุณก็อาจจะเสียโอกาสในการใช้ข้อมูลต่างๆที่มีให้เป็นประโยชน์มากที่สุด</li>
                    
                </ul>
            </div>

            <div className='pms-bottom'>
                <Link to='/products/pms/buy'>
                <button className="btn--package">คลิ๊ก! สั่งซื้อผลิตภัณฑ์</button>
                </Link>
                {!openButton1 ? 
                <div><br/><br/>
                    <button variant="contained" className='btn--erp' onClick={()=>{handleModal1()}}>Click OHO PMS MODULE 1/1</button>
                </div>
                : 
                <div><br/><br/>
                    <button variant="contained" className='btn--erp'  onClick={()=>{handleModalClose1()}}>hide 1/1</button>
                </div>
                    
                }{!openButton2 ? 
                <div><br/><br/>
                    <button variant="contained" className='btn--erp' onClick={()=>{handleModal2()}}>Click OHO PMS MODULE 1/2</button>
                </div> : 
                <div><br/><br/>
                    <button variant="contained" className='btn--erp'  onClick={()=>{handleModalClose2()}}>hide 1/2</button>
                </div>
                }
                {openModal1 && 
                    <div className='pms-bottom--img' style={{marginTop: '5%'}}>
                        <img src={img_pms1} alt='PMS-MODULE1' />
                    </div>
                }
                {openModal2 && 
                    <div className='pms-bottom--img' style={{marginTop: '5%'}}>
                        <img src={img_pms2} alt='PMS-MODULE2'/>
                    </div>
                }
            </div>
        </div>
    )
}